import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useRaisedFundsSummary from '../hooks/useRaisedFundsSummary';
import './PowerHourGlow.css';

const PowerHourGlow: React.FC = () => {
  const { data } = useRaisedFundsSummary();
  const [showText, setShowText] = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  // Check if any fund is power-hour-match with status 'active' and cap not reached
  const isPowerHourActive = data?.funds?.some(
    (fund: any) => fund.type === 'power-hour-match' && fund.status === 'active' && !fund.capReached
  );

  // Fade out text after 4 seconds
  useEffect(() => {
    if (isPowerHourActive && showText) {
      const timer = setTimeout(() => {
        setShowText(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [isPowerHourActive, showText]);

  if (!isPowerHourActive || dismissed) return null;

  const handleStarClick = () => {
    navigate('/raised');
  };

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDismissed(true);
  };

  return (
    <>
      <div className="power-hour-glow-border" />
      {showText && <div className="power-hour-text">POWER BOOST ACTIVE</div>}
      <div className="power-hour-corner">
        <button className="power-hour-star" onClick={handleStarClick} aria-label="Go to matching donors">
          ⭐
        </button>
        <button className="power-hour-dismiss" onClick={handleDismiss} aria-label="Dismiss power hour effect">
          ✕
        </button>
      </div>
    </>
  );
};

export default PowerHourGlow;
